module.exports = __webpack_public_path__ + "img/wa.7d70efe7.png";